import { observeFooterMeasure } from './monolyt-footer-measure.js?v=5fa0219cbf4cdff00cbf1e8692fd8add40177d14e31991e32bf9efdc2d2f08c0';

/* Align only the desktop logo to the existing text column, never move the column. */
class MonolytFooterLogo extends HTMLElement {
  connectedCallback() {
    this.cleanup?.();
    const footer = this.parentElement?.querySelector('.footer-content');
    const heading = footer?.querySelector('.monolyt-footer-nav__heading');
    if (!heading) return;

    const desktop = window.matchMedia('(min-width: 750px)');
    const measure = () => {
      if (!desktop.matches) {
        this.style.removeProperty('--footer-logo-start');
        return;
      }
      const band = this.getBoundingClientRect();
      const text = heading.getBoundingClientRect();
      if (band.width <= 0 || text.width <= 0) return;
      const start = `${Math.max(0, text.left - band.left)}px`;
      if (this.style.getPropertyValue('--footer-logo-start') !== start) {
        this.style.setProperty('--footer-logo-start', start);
      }
    };
    this.cleanup = observeFooterMeasure({
      host: this,
      elements: [this, footer, heading],
      mediaQuery: desktop,
      measure,
      cleanup: () => this.style.removeProperty('--footer-logo-start'),
      fontsReady: true,
    });
  }

  disconnectedCallback() {
    this.cleanup?.();
  }
}

if (!customElements.get('monolyt-footer-logo')) {
  customElements.define('monolyt-footer-logo', MonolytFooterLogo);
}
